<template>
    <div>
        <van-popup
            v-model="carshow"
            closeable
            position="bottom"
            :style="{ height: '70%' }">
            <van-address-list
                v-model="carID"
                :list="carlist"
                default-tag-text="Default"
                add-button-text='增加爱车'
                @select="selCar"
                @add="addCar"
                @edit="editCar"/>
            <div style="height: 30px"/>
        </van-popup>
        <AddCar ref="addcar" />
    </div>
</template>

<script>
import { 
    Popup, 
    AddressList, 
} from 'vant';
import { VipInfoApi } from '@/api/vip'
import AddCar from '@/view/user/components/addcar'
import { getCars } from '@/utils/localutils'

export default {
    name: 'SelCarModel',
    components: {
        [Popup.name]: Popup,
        [AddressList.name]: AddressList,
        AddCar,
    },
    data() {
        return {
            carshow: false,
            show: false,
            carID: 0,
            carlist: [],
            title: null,
        }
    },
    methods: {
        showDialog() {
            const car = getCars()
            if (car != null && car.cars !=null ) {
                const tmpCars = []
                car.cars.forEach((it) => {
                    tmpCars.push({
                        id: it.id,
                        category_id: it.carcategory_id,
                        series_id: it.series_id,
                        tel: '',
                        name: it.area_name + it.code,
                        address: it.carcategory_name
                        })
                    })
                tmpCars.push({
                    id: null,
                    category_id: null,
                    series_id: null,
                    tel: '',
                    name: '全部',
                    address: '所有车型'
                })
                this.carlist = tmpCars
                this.carshow = true
            }
            
        },
        save(){
            var that = this
            that.axios.post(VipInfoApi, that.from).then((ret) => {
                if(ret.flag){
                    that.show = false
                    that.getVipInfo()
                }
            }).catch((ex) => {
                console.log(ex)
            })
            that.show = false
        },
        selCar(item) {
            const ret = {
                car_id: item.id,
                carcategory_name: item.address,
                carcategory_id: item.category_id,
                series_id: item.series_id,
                car_code: item.name
            }
            this.$emit('pick', ret)
            this.carshow = false
        },
        addCar() {
            this.carshow = false
            this.$refs.addcar.add()
        },
        editCar(_, index) {
            console.log('editCar')
            console.log(index)
        },
        clickback() {
            try {
                this.$router.go(-1)
            } catch {
                this.$router.push(`/nt/user/membercentre`)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>